<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <div class="search-pg animals-pg">
      <h1 class="title-pg-default">{{ $t('База данных диких животных Кыргызстана') }}</h1>
      <SearchForm/>
      <div class="search-body bgw-pdg-20">
        <div class="type-column">
          <div class="columns-item">
            <v-row>
              <v-col
                cols="12"
                xs="12"
                sm="6"
                md="4"
                class="col-item"
                v-for="item in result"
                :key="item.id"
              >
                <div class="body" :class="{ img_empty: !item.img }">
                  <router-link :to="{ name: 'animal-view', params: { id: item.id }}">
                    <div class="img-col">
                      <template v-if="item.img">
                        <img :src="baseUrl + item.img.fullFilesDirectory" alt="arhar">
                      </template>
                      <template v-else>
                        <img src="@/assets/img/no-photo-animals.jpg" alt="image">
                      </template>
                    </div>
                    <h1>{{ item.name }}</h1>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Fauna from '@/model/fauna'
import { mapMutations } from 'vuex'
import SearchForm from '@/components/fauna/SearchForm'

export default {
  components: { SearchForm },
  data: () => ({
    breadcrumbs: [],
    baseUrl: process.env.VUE_APP_BACK_URL,
    result: []
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData'
  },
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)

      Fauna.getMainFauna().then((response) => {
        this.result = response.data
        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
          { text: this.$i18n.t('База данных диких животных КР'), disabled: true }
        ]
        this.setLoading(false)
      })
    }
  }
}
</script>
